<div class="language-switcher">
  <select class="language-switcher__select"
          [value]="activeLang()"
          (change)="selectLanguage($event)">
    @for (lang of languages; track lang.code) {
      <option [value]="lang.code">{{ lang.label }}</option>
    }
  </select>
</div>
